module.exports = __webpack_public_path__ + "img/59.adb7b4db.jpg";